import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL  

class NewsAndArticleApi {
    getAllNewsAndArticles() {
        return axios.get(BASE_URL + "/article/info");
    }
    getNewsAndArticleById(id) {
        return axios.get(BASE_URL + `/article/${id}`);
    }
    AddNewsAndArticle(data) {
        return axios.post(BASE_URL + "/article/add", data);
    }
    deleteNewsAndArticle(id) {
        return axios.delete(BASE_URL + `/article/${id}`);
    }
    updateNewsAndArticle(id, data) {
        return axios.put(BASE_URL + `/article/${id}`, data);
    }
}


export default new NewsAndArticleApi();
